export default __webpack_public_path__ + "static/media/Chrome-Logo.afd4c737.svg";